import * as APIRoutes from '@mm/api-routes';
import { snake } from '../helpers/converterString';
import { CompanyLevelFeatureFlag } from '../model/CompanyModel';
import AuthenticatedController from './AuthenticatedController';

export type SubscriptionFeatureFlag =
  | 'adsNewCtmAdsAutomaticSyncDisable'
  | 'adsNewCtmAdsManualSync'
  | 'adsOneNewCtmAd'
  | 'adsOneSponsoredAd'
  | 'adsSetupDripCampain'
  | 'adsSponsored'
  | 'adsUnlimitedNewCtmAds'
  | 'analytics'
  | 'analyticsAds'
  | 'analyticsBotContactsByPlatform'
  | 'analyticsBotContactsBySource'
  | 'analyticsBotFilterByDate'
  | 'analyticsBotKeywordsExport'
  | 'analyticsBotKeywordsTriggered'
  | 'analyticsBotViewAllDialogues'
  | 'analyticsBotViewUnansweredQuestions'
  | 'apiKey'
  | 'audiencesCreateCustom'
  | 'audiencesExportContacts'
  | 'audiencesSyncContacts'
  | 'automationDripCampaignsAcceptableTimebuilder'
  | 'automationRulesBusinessHours'
  | 'automationRulesFollowUps'
  | 'awaySetting'
  | 'botBuilderBotCloning'
  | 'botBuilderConditionalLogic'
  | 'botBuilderCreateFromTemplate'
  | 'botBuilderUnlimitedBots'
  | 'campaignsAudiencesSelection'
  | 'campaignsBlasterSend'
  | 'campaignsDripsSend'
  | 'campaignsScheduleSends'
  | 'chatBlasters'
  | 'commentGuardsEditFbPost'
  | 'connectionWidget'
  | 'connectPageUnlimitedPages'
  | 'contactSuppression'
  | 'customerChatAdvancedSettings'
  | 'customerChatEditConditions'
  | 'customerChatEditGreetingBehaviour'
  | 'customerChatEditorRemoveMMBranding'
  | 'customerChatGreetingEditor'
  | 'delayWidget'
  | 'desktopNotifications'
  | 'detailedDripStats'
  | 'dripCampaigns'
  | 'fbRestore'
  | 'jsonWebhook'
  | 'leadsAssignment'
  | 'mobileMonkeyApi'
  | 'nativeIntegrations'
  | 'notificationWidget'
  | 'qqFollowUps'
  | 'settingsCompanyLogoUpload'
  | 'smsActivateNumber'
  | 'templatesCreate'
  | 'userEdit'
  | 'userInvites'
  | 'userInvitesEditorAndAdmin'
  | 'voyagerEnrichment'
  | 'xray'
  | 'xrayAdvancedCaptureSettings'
  | 'zapier';

export type UpgradePlan = 'pro' | 'unicorn' | 'team2020';

export type RequiredPlan = 'pro' | 'unicorn' | 'team' | undefined;

export type FeaturesForPlans = {
  [k in SubscriptionFeatureFlag | CompanyLevelFeatureFlag]: UpgradePlan[];
};

export default class FeatureFlagsController extends AuthenticatedController {
  static getSubscriptionFeatures(
    facebookPageId: number,
  ): Promise<{ availableFeatures: SubscriptionFeatureFlag[] }> {
    return super.get(APIRoutes.FB_PAGE_FEATURES, snake({ facebookPageId }));
  }

  static getFeaturesForPlans(
    facebookPageId: number,
  ): Promise<{ upgradeList: FeaturesForPlans }> {
    return super.get(APIRoutes.FEATURES_FOR_PLANS, snake({ facebookPageId }));
  }
}
